// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

/**
 * Azure Playwright Reporter
 * Feature that uploads the report generated by the HTML reporter to the customer's storage account and
 * view them in the service portal for faster and easier troubleshooting.
 *
 * @packageDocumentation
 */

import playwrightReporter from "./playwrightReporter.js";

export default playwrightReporter;
